import { N900 } from '@atlaskit/theme/colors';
import styled from '@emotion/styled';
import React from 'react';
import { FormattedMessage } from 'react-intl';

export type PricingExampleHeaderProps = {
  unitCounts: number[];
};

export const PricingExampleHeader = ({ unitCount }: { unitCount: number }) => (
  <>
    <Header>
      <FormattedMessage
        id="billingDetailsBreakdown"
        defaultMessage="Billing details breakdown"
        description="Label for billing details breakdown"
      />
    </Header>
    <SubHeader>
      <FormattedMessage
        id="pricingUserCountMessage"
        defaultMessage="Pricing for {unitCounts} users"
        description="pricing for number of users text"
        values={{ unitCounts: unitCount }}
      />
    </SubHeader>
  </>
);

const Header = styled.h3`
  color: ${N900};
  font-family: Charlie Display;
  font-size: 20px;
  font-weight: 600;
  letter-spacing: 0.3px;
  line-height: 24px;
  margin: 0;
`;

const SubHeader = styled.div`
  color: ${N900};
  font-family: 'Charlie Text';
  font-size: 14px;
  font-weight: 400;
  line-height: 18px;
  margin-top: 4px;
`;
